
import Vue, { PropType, PropOptions } from 'vue'
import { PendingConnector } from '@root/src/types/main'
import TextField from '../../../../components/inputs/TextField.vue'
import { resolvePendingConnectorAltegio } from '../../../../api/pendingConnectors'
import { getAllAltegioCompanies } from '../../../../api/admin'
import SpinnerLoader from '../../../../components/SpinnerLoader.vue'
import CustomActivatorSelect from '../../../../components/inputs/CustomActivatorSelect.vue'
import BaseInputOutlined from '../../../../components/inputs/BaseInputOutlined.vue'
export default Vue.extend({
    name: 'PendingConnectorResolverYclients',
    components: { TextField, SpinnerLoader, CustomActivatorSelect, BaseInputOutlined },
    props: {
        pendingConnector: Object as () => PendingConnector,
    },
    data() {
        return {
            allCompanies: [] as any[],
            loading: true as boolean,
            selectedCompanies: [] as string[],
        }
    },
    computed: {},
    methods: {
        async resolve() {
            const res = await resolvePendingConnectorAltegio({
                id: this.pendingConnector.id,
                companyIds: this.selectedCompanies,
            })

            if (res.status > 200) {
                this.$store.dispatch('callNotify', 'Ошибка')
            } else {
                this.$router.push('/admin/pendingConnectors')
            }
        },
    },
    async created() {
        this.loading = true
        this.allCompanies = await getAllAltegioCompanies()
        this.loading = false
    },
})
